import React from 'react';
import styled from 'styled-components';

const WhyChooseUs = () => {
  return (
    <Container>
      <Header>OUR KEY HIGHLIGHTS</Header>
      <Section>
        <Card>
          <Icon>🎓</Icon>
          <Title>Expertise</Title>
          <Description>
          With 10+ years of experience, our consultants deliver tailored guidance to meet your academic needs.
          </Description>
        </Card>
        <Card>
          <Icon>🌍</Icon>
          <Title>Global Opportunities.</Title>
          <Description>
          We offer personalized services customized to clients needs.
          </Description>
        </Card>
        <Card>
          <Icon>⭐</Icon>
          <Title>Exceptional Support</Title>
          <Description>
          Our dedicated team provides unparalleled support, ensuring a seamless experience for every client.
          </Description>
        </Card>
        <Card>
          <Icon>💼</Icon>
          <Title>Professionalism</Title>
          <Description>
          Pristine Academic Consultancy upholds the highest standards of professionalism, dedicated to fostering talent and supporting the professional growth of its clients. 
          </Description>
        </Card>
      </Section>
    </Container>
  );
};

export default WhyChooseUs;

const Container = styled.div`
  background: linear-gradient(145deg, hsl(244, 93.60%, 49.20%), rgba(255, 255, 255, 0.6)), 
              url('/images/img77.jpg') no-repeat center;
  background-size: cover;
  color: #333;
  padding: 3rem 1.5rem;
  text-align: center;
  font-family: 'Poppins', sans-serif;
  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Header = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 2rem;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

const Section = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
`;

const Card = styled.div`
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 2rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out;

  &:hover {
    transform: translateY(-5px) scale(1.02);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.2);
  }
`;

const Icon = styled.div`
  font-size: 2rem;
  color: #ff5757;
  margin-bottom: 0.5rem;
`;

const Title = styled.h3`
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
`;

const Description = styled.p`
  font-size: 0.9rem;
  color: #555;
  line-height: 1.4;
  margin: 0;
`;
